module.exports = __webpack_public_path__ + "static/img/contact-banner.afc6048.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/contact-banner.jpg
// module id = Bkm2
// module chunks = 1